import { GoogleAnalyticsEventsService } from './../../../services/google-analytics-events.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-facet-tags',
  templateUrl: './facet-tags.component.html',
  styleUrls: ['./facet-tags.component.scss']
})
export class FacetTagsComponent implements OnChanges {
  @Input() facetMap: any = {};
  @Input() facets: any = {};
  @Input() pageName: string;

  @Output() removeFacet: EventEmitter<any>;

  tags: any[] = [];

  constructor(private googleAnalyticsService: GoogleAnalyticsEventsService) {
    this.removeFacet = new EventEmitter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.facetMap) {
      let _tags = [];
      changes.facetMap.currentValue.forEach((facet) => {
        Object.keys(facet).forEach(key => {
          facet[key].forEach((item, index) => {
            _tags = _tags.concat(
              [{ label: item.value, facetName: key, firstLvl: index, secondLvl: -1, isParent:!!(item.nestedFacetBag && item.nestedFacetBag.length) }],
              (item.nestedFacetBag || []).map((x, i) => ({
                label: item.value + ': ' + x,
                facetName: key,
                firstLvl: index,
                secondLvl: i
              }))
            );
          });
        });  
      });
      this.tags = _tags.filter(t=> {return !t.isParent;});
    }
  }

  onRemoveFacet(event, tag) {
    event.preventDefault();
    this.removeFacet.emit(tag);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Breadcrumb'), 'Icon Click', 'Breadcrumb removed');
  }
}
